export class CustomTimeValue {
  hours?: number;
  minutes?: number;
  seconds?: number;
}
